module.exports = __webpack_public_path__ + "img/payment-error.3083e2df.svg";